<script lang="ts" setup>
import { isPassword } from '@/refs/common.refs';
import type { IBaseInputProps } from '@/types/base_Input.types';
import { ref } from 'vue';

// -------------------------------
// 🔹 Props
// -------------------------------
/**
 * Props du composant input
 */
const props = defineProps<IBaseInputProps>();

// -------------------------------
// 🔹 v-model
// -------------------------------
const model = defineModel<string>();

// -------------------------------
// 🔹 Événements émis
// -------------------------------
/**
 * Événements émis par le composant :
 * - "HandleTextInput" : déclenché quand la valeur du champ change
 * - "HandleTextCheck" : déclenché pour activer le mode texte du mot de passe
 * - "HandlePassCheck" : déclenché pour désactiver le mode texte du mot de passe
 */
const emit = defineEmits<{
  (
    e: 'HandleTextInput',
    payload: Event,
    index?: number,
    secondIndex?: number,
  ): void;
  (e: 'HandleTextCheck'): void;
  (e: 'HandlePassCheck'): void;
}>();

// -------------------------------
// 🔹 Fonctions
// -------------------------------
/**
 * Gère le changement de valeur du champ et émet l'événement HandleTextInput
 * @param {Event} event Événement input
 */
const HandleChangeValue = (event: Event) => {
  emit('HandleTextInput', event, props.index, props.secondIndex);
};

/**
 * Active l'affichage du mot de passe en texte clair
 * Émet l'événement HandleTextCheck
 */
const HandleChangeIsPasword = () => {
  emit('HandleTextCheck');
  isPassword.value = true;
};

/**
 * Désactive l'affichage du mot de passe en texte clair
 * Émet l'événement HandlePassCheck
 */
const HandleCheckIsPaswordWord = () => {
  emit('HandlePassCheck');
  isPassword.value = false;
};
</script>

<template>
  <div class="flex flex-col gap-2">
    <label :for="id" class="text-14px font-tt-medium-Normal leading-normal">
      {{ label
      }}<span
        v-show="required"
        class="text-decroissance text-14px leading-normal"
        >*</span
      >
    </label>

    <div class="relative flex flex-row items-center">
      <input
        :disabled="disabled"
        @input="HandleChangeValue"
        class="caret-primary-900 focus-within:border-primary-900 filter-drop-shadow px-inline-16px py-vertical-12px box-border h-(--input-height) flex-1 rounded-[10px] outline-0"
        :required="required"
        :type="type"
        :name="name"
        :placeholder="placeholder"
        :id="id"
        v-model="model"
        :class="
          required === 'false'
            ? 'border-none'
            : 'border-border-input border border-solid focus-within:border focus-within:border-solid'
        "
      />
    </div>
  </div>
</template>
